import { Injectable } from '@angular/core';


export class FileHelper {

	public fallbackUrl: string;
	public rewriteMode: string;

	public rewriteUrl(url: string) {
		if (!url) {
			return '';
		}

		return url;
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/providers/file.service.ts